<!DOCTYPE html>
<html lang="fr">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>Politique de Confidentialité - ANVT Mobile</title>
    <style>
        body {
            font-family: Arial, sans-serif;
            line-height: 1.6;
            margin: 0;
            padding: 20px;
            color: #333;
        }
        h1 {
            color: #2c3e50;
            text-align: center;
        }
        h2 {
            color: #2980b9;
            margin-top: 25px;
            border-bottom: 1px solid #eee;
            padding-bottom: 5px;
        }
        .container {
            max-width: 800px;
            margin: 0 auto;
        }
        .last-update {
            font-style: italic;
            text-align: right;
            margin-bottom: 30px;
        }
    </style>
</head>
<body>
<div class="container">
    <h1>Politique de Confidentialité de l'Application Mobile ANVT</h1>
    <div class="last-update">Dernière mise à jour : 01/05/2025</div>

    <p>L'Agence Nationale du Volontariat au Togo (ANVT) est engagée à protéger votre vie privée. Cette politique de confidentialité explique comment nous collectons, utilisons, partageons et protégeons vos informations personnelles lorsque vous utilisez notre application mobile.</p>

    <h2>1. Informations que nous collectons</h2>
    <p>Nous collectons les informations suivantes lorsque vous utilisez notre application :</p>
    <h3>Pour les candidats (PVN) :</h3>
    <ul>
        <li>Informations d'identité (nom, prénoms, date de naissance, sexe, nationalité)</li>
        <li>Coordonnées (email, téléphone, adresse)</li>
        <li>Informations académiques (diplômes, formations, expériences professionnelles)</li>
        <li>Documents (CV, pièce d'identité, photos)</li>
        <li>Historique de candidature et suivi des étapes</li>
    </ul>

    <h3>Pour les structures d'accueil (PSA) :</h3>
    <ul>
        <li>Informations sur la structure (nom, secteur d'activité, statut juridique)</li>
        <li>Coordonnées (email, téléphone, adresse)</li>
        <li>Informations sur le référent (nom, poste, coordonnées)</li>
        <li>Demandes de missions et suivi des volontaires affectés</li>
    </ul>

    <h2>2. Comment nous utilisons vos informations</h2>
    <p>Nous utilisons vos informations pour :</p>
    <ul>
        <li>Gérer votre inscription et votre compte utilisateur</li>
        <li>Traiter et suivre votre candidature ou vos demandes de missions</li>
        <li>Vous informer sur l'évolution de votre dossier (par SMS, email ou notifications push)</li>
        <li>Établir des statistiques pour améliorer nos services</li>
        <li>Remplir nos obligations légales et réglementaires</li>
        <li>Assurer la sécurité de notre application et prévenir les fraudes</li>
    </ul>

    <h2>3. Partage de vos informations</h2>
    <p>Vos informations peuvent être partagées avec :</p>
    <ul>
        <li>Les structures d'accueil dans le cadre de votre affectation</li>
        <li>Les tuteurs et chargés de suivi pour l'évaluation de votre mission</li>
        <li>Les prestataires techniques assurant le fonctionnement de l'application</li>
        <li>Les autorités publiques lorsque requis par la loi</li>
    </ul>
    <p>Nous ne vendons pas vos informations personnelles à des tiers.</p>

    <h2>4. Sécurité des données</h2>
    <p>Nous mettons en œuvre des mesures techniques et organisationnelles appropriées pour protéger vos informations contre tout accès non autorisé, modification, divulgation ou destruction.</p>

    <h2>5. Conservation des données</h2>
    <p>Nous conservons vos informations pendant la durée nécessaire aux finalités pour lesquelles elles ont été collectées, conformément aux exigences légales.</p>

    <h2>6. Vos droits</h2>
    <p>Conformément à la loi n°2019-014 relative à la protection des données personnelles au Togo, vous avez le droit de :</p>
    <ul>
        <li>Accéder à vos informations personnelles</li>
        <li>Demander la rectification de données inexactes</li>
        <li>Demander la suppression de vos données dans certains cas</li>
        <li>Limiter le traitement de vos données</li>
        <li>Vous opposer au traitement de vos données</li>
        <li>Retirer votre consentement lorsque le traitement est basé sur celui-ci</li>
    </ul>
    <p>Pour exercer ces droits, veuillez nous contacter à : {{'anvt@togoanvt.org'}}</p>

    <h2>7. Cookies et technologies similaires</h2>
    <p>Notre application peut utiliser des cookies et des technologies similaires pour améliorer votre expérience utilisateur et analyser l'utilisation de l'application.</p>

    <h2>8. Modifications de cette politique</h2>
    <p>Nous pouvons mettre à jour cette politique de confidentialité. Nous vous informerons des changements significatifs via notre application ou par email.</p>

    <h2>9. Nous contacter</h2>
    <p>Pour toute question concernant cette politique ou la protection de vos données :</p>
    <p>Agence Nationale du Volontariat au Togo (ANVT)<br>
        ANVT situé à Klikamé,
        Rue 232 Aflao-Gakli, en face de la pharmacie Saint Joseph<br>
        Téléphone : +228 22 25 57 07<br>
        Email : {{'anvt@togoanvt.org'}}<br>
        Délégué à la Protection des Données : {{'serviceit@togoanvt.org'}}</p>
</div>
</body>
</html>
